import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import ModalContent from "../../../common/Modal/ModalContent";
import Spinner from "../../../common/Spinner/Spinner";
import close_modal from "./../../../assets/ic_close_wh.svg";
Modal.setAppElement("#root");

export default function RequestStateUpdateModal(props) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="general-modal">
				<div className="modal-header">
					<span className="modal-title">Progress the Service Request</span>
					<img
						alt="close"
						id="Close"
						src={close_modal}
						className="close modal-close"
						onClick={props.toggleModal}
					/>
				</div>
				<div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${props.isLoading && "set-opacity"}`}>
					{props.isLoading && <Spinner className="top"/>}
					<div className="conv-mt10">{props.renderMe}</div>
					<button 
						type="button" 
						disabled={
							props.deliveryMode === "Self-Served" ||
							props.isDisabled ||
							props.isMovedToSPM
						  }
						  
						// disabled={props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"}
						className={`my-services-model-submit-btn conv-pr15 conv-pl15 conv-mt10 conv-mb10
						${props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"?"disabled":"" || props.isMovedToSPM === "false" || props.isMovedToSPM ? "my-services-model-disabled-btn" : ""}`}
						onClick={() =>props.handleSave()}>
						Save
					</button>
				</div>
					
			</ModalContent>
		</Modal>
	);
}
